const translationData = {
  ca: {
    application: {
      title: "Catala",
      hello: "Hello"
    },
    navBar: {
      inicio: "Inici",
      servicios: "Serveis",
      produccionesPropias: "Produccions pròpies",
      quienesSomos: "Qui som",
      contacto: "Contacte"
    },
    main: {
      subtitle: "Els nostres serveis",
      videoButton: "Veure video promo",
      accept: 'Entès',
      cancel: 'Rebutjar',
      pasion: "Pasió",
      hoverCard: {
        play: "Reproduir",
        hoverCard0: {
          backText: "EL EQUIPO VERSATIL está experimentado en el sector de los eventos, conoce el entorno y sabe que el éxito final recae en empezar escuchando y ejecuta sin perder la visión del cliente",
          titleKey: "Què fem"
        },
        hoverCard1: {
          backText: "Festival de Rock de carácter gratuito que se celebra el segundo sábado del mes Julio en el parque de Can Mercader de Cornellá de Llobregat.",
          titleKey: "Can Mercader Festival"

        }
      },
      privacy: 'Utilitzem cookies pròpies i de tercers per millorar els nostres serveis, elaborar informació estadística i analitzar els seus hàbits de navegació. Això ens permet personalitzar el contingut que oferim i mostrar publicitat relacionada amb les seves preferències. En clicar a "Entès" ACCEPTA EL SEU ÚS. També pot REBUTJAR la instal·lació de cookies clicant a "Rebutjar".'
    },
    services: {
      serviceCards: {
        alquilerEquipos: "Lloguer d'equips",
        gruposMusicales: "Grups musicals, DJ's i artistes",
        carpas: "Carpes",
        catering: "Càtering",
        decoraciones: "Decoracions i mobiliari per a esdeveniments",
        gestionEspacios: "Gestió d'espais",
        versatilRecording: "Versàtil Recording Studio",
      },
      text: {
        factoriaMusicalTitle: "Factoria Musical",
        alquilerEquipos: "Oferim servei de lloguer d’equips de so i llums amb personal tècnic. L’alta qualitat del nostre material i l’experiència dels nostres tècnics proporcionen als nostres esdeveniments i espectacles elegància i professionalitat.",
        gruposMusicales: "Disposem d’un gran ventall de bandes de versions, orquestres, grups tribut, grups de cançons pròpies de tots els estils, DJ’s i tot tipus d’artistes relacionats amb el món de l’espectacle.",
        carpas: "El muntatge de carpes per a esdeveniments és una de les nostres especialitats. Disposem d’un gran ventall de models que s’adapten a les necessitats de cada espai. Els nostres professionals li assessoraran sobre el tipus de muntatge i model més adequats pel seu esdeveniment.",
        catering: "Càtering a mida per a empreses, particulars, esdeveniments i rodatges.",
        decoraciones: "Oferim serveis de decoració d’espais tant per a interiors com per a exteriors. Disposem de mobiliari exclusiu adequat per a tot tipus d’esdeveniments, així com professionals en decoració llumínica per a esdeveniments nocturns.",
        gestionEspacios1: "La Factoria Musical és un complex municipal de Cornellà. Disposa de locals d'assaig, sala de concerts i estudi de gravació.",
        gestionEspacios2: "La sala Ramon Romagosa és el teatre del 'Patronat Cultural i Recreatiu de Cornellà'. Ens encarreguem de la producció tècnica, regidories, gestió de personal tècnic i manteniment de la sala.",
        versatilRecording: {
          estudioGrabacionTitle: "ESTUDI DE GRAVACIÓ",
          estudioGrabacionText1: "Estudi de so professional ubicat a Cornellà de Llobregat, dedicat a la gravació de grups musicals (en directe o sessions), gravació de locucions, bandes sonores, foleys, disseny de sons, postproducció, edició, mescla i mastering.",
          estudioGrabacionText2: "Consta de 3 sales perfectament aïllades, acondicionades acústicament i climatitzades per tenir unes condicions de treball idònees.",
          personalTitle: "PERSONAL",
          personalText: "Personal format per l’American World University i amb certificat Protools Operator, amb anys d’experiència en el sector.",
          trabajosRealizadosTitle: "TREBALLS REALITZATS",
          gruposRegistradosTitle: "Grups enregistrats:",
          gruposRegistradosText: "Bunker, Suspiria, Impostores, David Yepes, Bisonte vs Bufalo, Döria, Ferranea, Daeria, Deceleratrix, Sense nom, V&B, 'flamenc'.",
          postProduccionTitle: "Postproducció de so:",
          postProduccionText: "Brutal gadtget, Tenemos visita, Garra charrúa, chavalas, súper chavalas, Camilo",
          bandasSonorasTitle: "Bandes sonores:",
          bandasSonorasText: "A Little taste, Tenemos visita, diferentes jingles para publicidad (oreo, mastercard, león)"
        },
        soundCloudText: "Escolta les nostres gravacions a"
      },
      pidaPresupuesto: "Demani pressupost",
      actividadesFactoria: "Activitats 2019",
      verCatalogo: "Veure catàleg",
      listadoMaterial: "Llistat de material"
    },
    produccionesPropias: {
      title: "Produccions pròpies",
      cards: {
        canMercader: {
          title: "Can Mercader Festival",
          text: "Actualment, és un dels festivals gratuïts de Rock i Metal més populars a nivell estatal. Està organitzat per l’Ajuntament de Cornellà, i des de l’any 2015, estem portant a terme la seva direcció i producció, tant a nivell tècnic com artístic."
        },
        feriaVinos: {
          title: "Fira de vins",
          text: "La producció i muntatge de fires gastronòmiques és una de les nostres especialitats. Oferim serveis d’il·luminació arquitectònica, instal·lació de sistemas de so per fil musical, muntatge de carpes i garlandes, així com shows musicals que s’adapten a les necessitats de l’espai creant un ambient festiu i avantguardista."
        },
        fiestaFluor: {
          title: "Festa Fluor",
          text: "La combinació de música, pintures fluorescents i objectes lluminosos, junt amb la llum negra són el resultat d'una festa fluor. A VERSÀTIL us proporcionem tots els elements artístics, tècnics i decoratius que el client pugui imaginar per tal de fer de la seva Festa Fluor un espectacle que marqui tendència."
        },
        randomKieb: {
          title: "Random Kieb Show",
          text: "Dj Jon Kieb presenta el seu nou espectacle 'Random Kieb Show', un show musical pensat per a entretenir a tots els públics. La mescla d'estils variada, la contínua aparició de cantants i artistes així com tots els elements de joc que intervenen en el seu directe, no deixaran a ningú indiferent. La interacció amb el públic en clau de concurs és un dels principals al·licients d'aquest espectacle, acompanyat d'un espai d'ambientació disco i centenars d'obsequis per a tots els participants."
        },
      }
    },
    quienesSomos: {
      title: "Qui som",
      text: "En Xavi Alloza i en Javier Rodríguez vàrem crear Versàtil Produccions l’any 2016 per disenyar, produir i gestionar espectacles, esdeveniments i activitats lúdiques de qualitat. Actualment, l’EQUIP VERSÀTIL està format per professionals amb més de 10 anys d’experiència en el sector dels esdeveniments. Aquest equip coneix el sector i sap que la clau de l’èxit recau en escoltar el client i dur a terme les seves idees respectant sempre la seva visió inicial. Per aquest motiu, posem els cincs sentits a les necessitats dels nostres clients i les tenim en compte des del primer contacte fins a la culminació de la nostra feina."
    },
    contacto: {
      title: "Contacte",
      enviar: "Enviar",
      cerrar: "Tancar",
      formText: "Indiqui el seu nom i el seu E-mail i ens posarem en contacte amb vostè el més aviat possible.",
      nombre: 'Nom',
      mensaje: 'Missatge',
      telefonoFijo: "Telèfon fixe",
      produccionTecnica: "Producció tècnica",
      depComercial: "Dep. comercial",
      info: "Informació",
      admin: "Administració",
      privacyPolicy: 'Estic d\'acord amb l\'Avís Legal i la Política de privacitat'
    },
    snackbar: {
      success: 'Missatge enviat correctament',
      error: 'Error enviant missatge. Intenteu-ho de nou'
    },
    policy: {
      title: 'Polítiques de Privacitat i Avís legal',
      text: "Les presents condicions d'ús regulen l’accés a aquesta web per part dels clients de VERSÀTIL PRODUCCIONS i altres usuaris d’Internet. Per navegar a aquesta web, l’usuari manifesta la seva acceptació sense excepcions de les presents condicions d’ús. VERSÀTIL PRODUCCIONS es reserva el dret unilateral de modificar les presents condicions d'accés a la web, així com els continguts inclosos. Limitació i exclusió de responsabilitat El contingut d'aquesta web és de caràcter general i té una finalitat i efectes exclusivament informatius. VERSÀTIL PRODUCCIONS no accepta responsabilitat sobre qualsevol informació no elaborada per ella o publicada al seu nom sense la seva autorització, així com responsabilitat derivada de la mala utilització per tercers dels continguts. L’usuari eximeix VERSÀTIL PRODUCCIONS de qualsevol responsabilitat que pogués derivar-se de les interrupcions de disponibilitat de la pàgina web, ja sigui per mal funcionament del servidor web o de les aplicacions, de les infraestructures de comunicacions o del software i hardware utilitzats per a la navegació. En cas d’incloure enllaços a d’altres pàgines web, VERSÀTIL PRODUCCIONS declina qualsevol responsabilitat relacionada amb els accessos als mateixos."
    }
  },
  es: {
    application: {
      title: "Castellano"
    },
    navBar: {
      inicio: "Inicio",
      servicios: "Servicios",
      produccionesPropias: "Producciones propias",
      quienesSomos: "Quienes somos",
      contacto: "Contacto"
    },
    main: {
      subtitle: "Nuestros servicios",
      videoButton: "ver video promo",
      accept: 'Aceptar',
      cancel: 'Rechazar',
      pasion: "Pasión",
      hoverCard: {
        play: "Reproducir",
        hoverCard0: {
          backText: "EL EQUIPO VERSATIL está experimentado en el sector de los eventos, conoce el entorno y sabe que el éxito final recae en empezar escuchando y ejecuta sin perder la visión del cliente",
          titleKey: "Qué hacemos"
        },
        hoverCard1: {
          backText: "Festival de Rock de carácter gratuito que se celebra el segundo sábado del mes Julio en el parque de Can Mercader de Cornellá de Llobregat.",
          titleKey: "Festival Can Mercader"
        }
      },
      privacy: 'Utilizamos cookies propias y de terceros para mejorar nuestros servicios, elaborar información estadística y analizar su hábitos de navegación. Esto nos permite personalizar el contenido que ofrecemos y mostrar publicidad relacioada con sus preferencias. Presionando en "Aceptar" ACEPTA SU USO. También puede RECHAZAR la instalación de cookies presionando en "Rechazar".'
    },
    services: {
      serviceCards: {
        alquilerEquipos: "Alquiler de equipos",
        gruposMusicales: "Grupos musicales, DJ's y artistas",
        carpas: "Carpas",
        catering: "Catering",
        decoraciones: "Decoraciones y mobiliario para eventos",
        gestionEspacios: "Gestión de espacios",
        versatilRecording: "Versátil Recording Studio"
      },
      text: {
        factoriaMusicalTitle: "Factoría Musical",
        alquilerEquipos: "Ofrecemos servicio de alquiler de equipos de sonido y luces con personal técnico. La alta calidad de nuestro material y la experiencia de nuestros técnicos proporcionan a nuestros eventos y espectáculos elegancia y profesionalidad.",
        gruposMusicales: "Disponemos de un gran abanico de bandas de versiones, orquestas, grupos tributo, grupos de canciones propias de todos los estilos, DJ’s y todo tipo de artistas relacionados con el mundo del espectáculo.",
        carpas: "El montaje de carpas para eventos es una de nuestras especialidades. Disponemos de una gran variedad de modelos que se adaptan a las necesidades de cada espacio. Nuestros profesionales le asesorarán sobre el tipo de montaje y los modelos más adecuados para su evento.",
        catering: "Catering a medida para empresas, particulares, eventos y rodajes.",
        decoraciones: "Ofrecemos servicios de decoración de espacios tanto para interiores como para exteriores. Disponemos de mobiliario exclusivo adecuado para todo tipo de eventos, así como profesionales en decoración lumínica para eventos nocturnos.",
        gestionEspacios1: "La Factoria Musical  es un complejo municipal de Cornellá. Dispone de locales de ensayo, sala de conciertos y estudio de grabación.",
        gestionEspacios2: "La sala Ramon Romagosa es el teatro del “Patronat Cultural i Recreatiu de Cornellà”. Nos encargamos de la producción técnica, regidurías, gestión del personal técnico y mantenimiento de la sala.",
        versatilRecording: {
          estudioGrabacionTitle: "ESTUDIO DE GRAVACIÓN",
          estudioGrabacionText1: "Estudio de sonido profesional ubicado en Cornellà de Llobregat, dedicado a la grabación de bandas musicales (en directo o sesiones), grabación de locuciones, bandas sonoras, foleys, diseño de sonidos, postproducción, edición, mezcla y mástering.",
          estudioGrabacionText2: "Consta de 3 salas perfectamente aisladas, acondicionadas acústicamente y climatizadas para tener unas condiciones de trabajo idóneas.",
          personalTitle: "PERSONAL",
          personalText: "Personal formado por la American World University y con certificado Protools Operator, con años de experiencia en el sector.",
          trabajosRealizadosTitle: "TRABAJOS REALIZADOS:",
          gruposRegistradosTitle: "Bandas grabadas:",
          gruposRegistradosText: "Bunker, Suspiria, Impostores, David Yepes, Bisonte vs Bufalo, Döria, Ferranea, Daeria, Deceleratrix, Sense nom, V&B, 'flamenc'.",
          postProduccionTitle: "Postproducción de sonido:",
          postProduccionText: "Brutal gadtget, Tenemos visita, Garra charrúa, chavalas, súper chavalas, Camilo",
          bandasSonorasTitle: "Bandas sonoras:",
          bandasSonorasText: "A Little taste, Tenemos visita, diferentes jingles para publicidad (oreo, mastercard, león)"
        },
        soundCloudText: "Escucha nuestras grabaciones en"
      },
      pidaPresupuesto: "Pida presupuesto",
      actividadesFactoria: "Actividades 2019",
      verCatalogo: "Ver catálogo",
      listadoMaterial: "Listado de materiales"
    },
    produccionesPropias: {
      title: "Producciones propias",
      cards: {
        canMercader: {
          title: "Can Mercader Festival",
          text: "Actualmente, es uno de los festivales gratuitos de Rock y Metal más populares a nivel estatal. Está organizado por el Ayuntamiento de Cornellá, y desde el año 2015, llevamos a cabo su dirección y producción, tanto a nivel técnico como artístico."
        },
        feriaVinos: {
          title: "Feria de vinos",
          text: "La producción y montaje de ferias gastronómicas es una de nuestras especialidades. Ofrecemos servicios de iluminación arquitectónica, instalación de sistemas de sonido para hilo musical, montaje de carpas y guirnaldas, así como shows musicales que se adaptan a las necesidades del espacio creando un ambiente festivo y vanguardista."
        },
        fiestaFluor: {
          title: "Fiesta Flúor",
          text: "La combinación de música, pinturas fluorescentes y objetos luminosos unido a la luz negra son el resultado de una fiesta flúor. En VERSÁTIL proporcionamos todos los elementos artísticos, técnicos y decorativos que el cliente pueda imaginar para hacer de su Fiesta Flúor un espectáculo que marque tendencia."
        },
        randomKieb: {
          title: "Random Kieb show",
          text: "Dj Jon Kieb presenta su nuevo espectáculo 'Random Kieb Show', un show musical pensado para entretener a todos los públicos. La mezcla de estilos variada, la continua aparición de cantantes y artistas, así como todos los elementos de juego que intervienen en su directo, no dejarán a nadie indiferente. La interacción con el público en clave de concurso es uno de los principales alicientes de este espectáculo, acompañado de un espacio de ambientación disco y cientos de obsequios para todos los participantes."
        },
      }
    },
    quienesSomos: {
      title: "Quiénes somos",
      text: "Xavi Alloza y Javier Rodríguez creamos Versàtil Produccions en el año 2016 para diseñar, producir y gestionar espectáculos, eventos y actividades lúdicas de calidad. Actualmente, el EQUIPO VERSÁTIL está formado por profesionales con más de 10 años de experiencia en el sector de los eventos. Este equipo conoce el sector y sabe que la clave del éxito recae en escuchar al cliente y ejecutar sus ideas sin perder su enfoque. Por este motivo, ponemos los cinco sentidos en las necesidades del cliente y las tenemos en cuenta desde el primer contacto hasta la culminación de nuestro trabajo."
    },
    contacto: {
      title: "Contacto",
      enviar: "Enviar",
      cerrar: "Cerrar",
      formText: "Indique su nombre y su E-mail y nos pondremos en contacto con usted lo antes posible",
      nombre: 'Nombre',
      mensaje: 'Mensaje',
      telefonoFijo: "Teléfono fijo",
      produccionTecnica: "Producción técnica",
      depComercial: "Dep. comercial",
      info: "Información",
      admin: "Administración",
      privacyPolicy: 'Acepto el Aviso Legal y la Política de privacidad'
    },
    snackbar: {
      success: 'Mensaje enviado correctamente',
      error: 'Error enviando mensaje. Inténtelo de nuevo'
    },
    policy: {
      title: 'Política de Privacidad y Aviso Legal',
      text: "Las presentes condiciones de uso regulan el acceso a esta web por parte de los clientes de VERSÀTIL PRODUCCIONS y de otros usuarios de internet. Para navegar en esta web, el usuario manifiesta su aceptación sin excepciones de las presentes condiciones de uso. VERSÀTIL PRODUCCIONS se reserva el derecho unilateral de modificar las presentes condiciones de acceso a la web, así como los contenidos que se incluyen. Limitación y exclusión de responsabilidad. El contenido de esta web es de carácter general y tiene una finalidad y efectos exclusivamente informativos. VERSÀTIL PRODUCCIONS rechaza la responsabilidad sobre cualquier información no elaborada por ella o publicada en su nombre sin previa autorización, así como la responsabilidad derivada del mal uso por terceros de los contenidos. El usuario exime a VERSÀTIL PRODUCCIONS de cualquier responsabilidad que pudiera derivarse de las interrupciones de disponibilidad de la página web, ya sea por mal funcionamiento del servidor web o de las aplicaciones, de las infraestructuras de comunicaciones o del software y hardware utilizados en la navegación. En el caso de que se incluyan enlaces a otras páginas web, VERSÀTIL PRODUCCIONS rechaza cualquier responsabilidad relacionada con los accesos a estos."
    }
  }
};

export default translationData;
